import styles from './node.module.css'

const typeClassess = {
  flow: styles['type-flow'],
  system: styles['type-system'],
}

export const generateClassess = (
  type: 'flow' | 'system',
  isActive: boolean,
  isSelected: boolean,
) => {
  return `${styles.core} ${typeClassess[type]} ${!isActive ? styles.inactive : ''} ${
    isSelected ? styles.selected : ''
  }`
}
